


















































































































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import RegexValidators from '@/shared/regex-validators';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { StateList } from '../statesList';
import { Country, State } from '../../shared/country-state-component/types';
import { DEFAULT_TEXTFIELD_WIDTH, initialAddressInfo } from './billing-constants';
import { AddressInfo } from './types';
const cssPrefix = 'billingInfo';
@Component({
  components: {
    ...UUIFComponents,
  },
})
export default class BillingInfo extends SwExtendedVue {
  cssPrefix = cssPrefix;
  fieldWidth: string = DEFAULT_TEXTFIELD_WIDTH.toString();
  @Prop({ type: Object })
  customerInfo: any;
  addressInfo: AddressInfo = { ...initialAddressInfo };
  countries: any = [];
  states: any = [];
  showCAorUS: boolean = false;
  isSubmitted : boolean = false;
  isguestbuynow: boolean = false;
  showVat: boolean = false;
  showGst: boolean = false;
  isSaveAddress: boolean = false;
  emailValidator = new RegExp(RegexValidators.email);
  phoneNoValidator = new RegExp(RegexValidators.phoneNo);

  get countriesOptions() : SelectOption[]  {
    const tempArr: SelectOption[] = [];
    this.countries.map((country: Country) => {
      tempArr.push({
        id: country.countryCode ? country.countryCode : '',
        value: country.countryCode ? country.countryCode : '',
        label: country.countryName ? country.countryName : '',
      });
    });
    return tempArr;
  }

  get statesOptions() : SelectOption[] {
    const tempArr: SelectOption[] = [];
    this.states = this.addressInfo.country === 'US' ? [...StateList.US] : this.addressInfo.country === 'CA' ? [...StateList.CA] : [];
    this.states && this.states.map((state: State) => {
      tempArr.push({
        id: state.stateCode ? state.stateCode : '',
        value: state.stateCode ? state.stateCode : '',
        label: state.stateName ? `${this.$t(state.stateName)}` : '',
      });
    });
    return tempArr;
  }

  mounted() {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getCountriesFromServer', 'NO')
    .then((resp) => {
      if (resp?.operationStatus === 'OK') {
        this.$store.commit('stopLoading');
        this.countries = resp?.content?.lstCountries ||  [];
        this.setAddressInfo(this.customerInfo);
      }
    });
  }

  setAddressInfo(data: any) {
    this.addressInfo.fullName = data.fullName || '';
    this.addressInfo.address1 = data.addressLine1 || '';
    this.addressInfo.address2 = data.addressLine2 || '';
    this.addressInfo.city = data.city || '';
    this.addressInfo.zipcode = data.zipCode || '';
    this.addressInfo.phone = data.phoneNumber || '';
    this.addressInfo.country = data.country || '';
    this.addressInfo.state = data.state || '';
    this.addressInfo.province = data.province || '';
    this.addressInfo.emailAddress = data.emailAddress || '';
    this.addressInfo.vatNumber = data.vatNumber || '';
    this.addressInfo.gstNumber = data.gstNumber || '';
    this.showCAorUS = this.addressInfo.country === 'US' || this.addressInfo.country === 'CA';
  }

  onCountryChange() {
    this.addressInfo.vatNumber = '';
    this.addressInfo.gstNumber = '';
    this.showVat = this.countries.filter((cotry: Country) => { return cotry.countryCode === this.addressInfo.country; })[0].isVatRequired;
    this.showGst = this.countries.filter((country: Country) => { return country.countryCode === this.addressInfo.country; })[0].isGstRequired;
    if (this.addressInfo.country === 'US' || this.addressInfo.country === 'CA') {
      this.showCAorUS = true;
      this.states = this.addressInfo.country === 'US' ? [...StateList.US] :
      this.addressInfo.country === 'CA' ? [...StateList.CA] : [];
      const stateCode = this.states.filter((state : State) => state.stateCode === this.addressInfo.state)[0]?.stateCode || '';
      this.addressInfo.state = stateCode ? stateCode : this.states[0].stateCode;
    } else {
      this.showCAorUS = false;
      this.addressInfo.province = this.addressInfo.province ? this.addressInfo.province : '';
    }
  }

  submitBillingInfo() {
    this.isSubmitted = true;
    if (this.validateAddressInfo()) {
      const payload = {
        ...this.addressInfo,
        state: this.showCAorUS ? this.addressInfo.state :  '',
        vatNumber: this.showVat ? this.addressInfo.vatNumber : '',
        gstNumber: this.showGst ? this.addressInfo.gstNumber : '',
        customerAddressId: this.customerInfo?.customerAddressID,
        enccardetails: '',
        autoRenewalId: '',
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('SnbProfileStoreModule/updateBillingInfo', payload)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          this.closeDialog(true);
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          this.closeDialog(false);
        }
      });
    }
  }

  validateAddressInfo() {
    // tslint:disable-next-line:max-line-length
    if (this.addressInfo.fullName !== '' && this.addressInfo.address1 !== '' && this.addressInfo.city !== '' && this.addressInfo.zipcode !== '' && this.addressInfo.phone !== '' && this.addressInfo.country !== '' && this.addressInfo.emailAddress !== '') {
      if (!this.addressInfo.emailAddress?.match(this.emailValidator) || !this.addressInfo.phone?.match(this.phoneNoValidator)) {
        return false;
      }
      if (!this.showCAorUS && this.addressInfo.province === '') {
        return false;
      }
      if ((this.showVat && this.addressInfo.vatNumber === '') || (this.showGst && this.addressInfo.gstNumber === '')) {
        return false;
      }
    } else {
      return false;
    }
    return true;
  }

  closeDialog(status: boolean) {
    this.$emit('closeBillingInfoDialog', status);
  }
}
